import { Fragment } from 'react';
import { ColorOption } from './color-palete-map';
import styles from './color-picker.module.scss';

export const DropDownMenu = ({
  colors,
  selected,
  handleSelect,
  isOpen,
}: {
  colors: ColorOption[];
  selected: ColorOption | null;
  handleSelect: (color: ColorOption) => void;
  isOpen: boolean;
}) => {
  return (
    <Fragment>
      {isOpen && (
        <ul className={styles.menu} role="listbox">
          {colors.map((color) => (
            <li
              key={color.hex}
              className={styles.item}
              onClick={() => handleSelect(color)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSelect(color);
                }
              }}
              role="option"
              aria-selected={selected?.hex === color.hex}
              tabIndex={0}
            >
              {color.hex !== 'HEXCOLOR' && (
                <span
                  className={styles.colorBox}
                  style={{ backgroundColor: color.hex }}
                />
              )}
              <span className={styles.colorHex}>{color.hex}</span> -&nbsp;
              {color.label}
            </li>
          ))}
        </ul>
      )}
    </Fragment>
  );
};
